import { ref, readonly, useContext } from "@nuxtjs/composition-api";
import { useApi } from "@wemade-vsf/composables";
import getAttachmentsGql from "./getAttachments.gql";
function useAttachments() {
  const loading = ref(false);
  const error = ref({
    getAttachments: null
  });
  const { query } = useApi();
  const { app: { $vsf: { $magento } } } = useContext();
  const attachmentBaseUrl = `${$magento.config.magentoBaseUrl}/media/productattach`;
  const getAttachments = async (ids) => {
    loading.value = true;
    let result = null;
    try {
      const { data } = await query(getAttachmentsGql, { id: ids });
      result = (data == null ? void 0 : data.ProductAttachments) ? data.ProductAttachments.map((a) => {
        return {
          ...a,
          file: a.file ? attachmentBaseUrl + a.file : null
        };
      }).sort((a, b) => ids.indexOf(a.productattach_id) - ids.indexOf(b.productattach_id)) : null;
    } catch (err) {
      error.value.getAttachments = err;
    } finally {
      loading.value = false;
    }
    return result;
  };
  return {
    loading: readonly(loading),
    error: readonly(error),
    getAttachments
  };
}
export {
  useAttachments
};
